import { render, staticRenderFns } from "./Subscribers.vue?vue&type=template&id=1baa05a4"
import script from "./Subscribers.vue?vue&type=script&lang=js"
export * from "./Subscribers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1baa05a4')) {
      api.createRecord('1baa05a4', component.options)
    } else {
      api.reload('1baa05a4', component.options)
    }
    module.hot.accept("./Subscribers.vue?vue&type=template&id=1baa05a4", function () {
      api.rerender('1baa05a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/subscription_plan/Subscribers.vue"
export default component.exports